import * as React from 'react';
import * as _ from 'lodash';

import BaseRequirementInput from './BaseRequirementInput';

namespace UnformattedRequirementInput {
  export interface OpenModalDisplayPart {
    type: 'openModal';
    display: string;
    textScreenId: string;
    headerText: string;
  }

  export type DisplayPart = BaseRequirementInput.DisplayPart | OpenModalDisplayPart;

  export interface Props extends InputProps {
    displayParts: DisplayPart[];
  }
}

function displayPartIsOpenModalType(
  displayPart: UnformattedRequirementInput.DisplayPart,
): displayPart is UnformattedRequirementInput.OpenModalDisplayPart {
  return _.get(displayPart, 'type') === 'openModal';
}

// A wrapping component of CheckboxInput that makes it easier to generate checkboxes with custom text
// that can open a modal. Essentially, a version of FormattedUnformattedRequirementInput with more consumer control.
class UnformattedRequirementInput extends React.PureComponent<UnformattedRequirementInput.Props> {
  generateDisplayParts: BaseRequirementInput.Props['generateDisplayParts'] = openModal => {
    const { displayParts } = this.props;
    return _.map(displayParts, displayPart => {
      if (displayPartIsOpenModalType(displayPart)) {
        return {
          display: displayPart.display,
          onClick: () => openModal(displayPart.textScreenId, displayPart.headerText),
        };
      }
      return displayPart;
    });
  };

  render() {
    const { displayParts: _displayParts, ...inputProps } = this.props;

    return <BaseRequirementInput generateDisplayParts={this.generateDisplayParts} {...inputProps} />;
  }
}

export const UnformattedRequirementInputConfig = {
  component: UnformattedRequirementInput,
};

export default UnformattedRequirementInput;
